import { useFormContext } from "react-hook-form";
import { UserLoginErrorCode } from "common-client/generated/graphql";
import { Button } from "../../Common/Button";
import { ButtonLink } from "../../Common/ButtonLink";
import { Section, Sections } from "../../Common/Layout";
import { Body, Title } from "../../Common/Typography";
import { Text } from "../../Inputs/react-hook-form";
import SecondaryActions from "../CommonLoginComponents/SecondaryActions";
import { ErrorMessage } from "../ErrorMessage";
import { LoginFormStructure } from "../LoginPage";

export const ProvideCode = ({
  title,
  subtitle,
  onBack,
  secondaryActions,
  onSubmit,
  error,
  disabled,
}: {
  title: string;
  subtitle: string;
  onBack?: () => void;
  secondaryActions?: {
    onClick: () => void;
    text: string;
    disabled?: boolean;
  }[];
  onSubmit: (data: LoginFormStructure) => void;
  error: Maybe<{ message: string; code?: UserLoginErrorCode }>;
  disabled?: boolean;
}) => {
  const { register, handleSubmit, watch } = useFormContext();

  const code = watch("code");

  return (
    <Sections as="form" onSubmit={handleSubmit(onSubmit)}>
      {error && <ErrorMessage error={error} />}
      <Section>
        <Title type="semiBold" size="large">
          {title}
        </Title>
        <Body size="default" type="regular">
          {subtitle}
        </Body>
        <div>
          <Text
            label="Authentication code"
            {...register("code")}
            placeholder="******"
            autoComplete="off"
          />
          {!!secondaryActions?.length && (
            <SecondaryActions actions={secondaryActions} />
          )}
        </div>
      </Section>
      <Section style={{ alignItems: "center" }}>
        <Button
          type="submit"
          disabled={disabled || !code}
          size="medium"
          styleVariant="primary"
          stretch
        >
          Submit
        </Button>
        {onBack && (
          <ButtonLink onClick={onBack} size="medium" styleVariant="primary">
            Back
          </ButtonLink>
        )}
      </Section>
    </Sections>
  );
};
